/* eslint-disable no-console */
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Alert, Box, LinearProgress, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import WebViewer from '@pdftron/webviewer';
import axios from 'axios';
import { XMLParser } from 'fast-xml-parser';
import fileDownload from 'js-file-download';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import appConfig from 'src/appConfig';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import config from 'src/data/config';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import StyledMenu from 'src/theme/StyledTheme';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocManagementService from '../documentUpload/service/DocManagementService';
import SendasLink from '../modelViewer/SendasLink';
import AddtoTasksDialogComponent from './AddtoTasksDialogComponent';
import ApprovalWorkflowDialog from './ApprovalWorkflowDialog';
import AuditHistory from './AuditHistory';
import AccordionMetadataComponent from './component/AccordionComponent';
import './DocumentViewer.scss';
import { GetMetaData } from './helper/DocumentViewerHelper';
import MetaDetail from './MetaDetail';
import MetricsDetails from './MetricsDetails';
import QualityControlDetail from './QualityControlDetail';
import Remove from './Remove';
import ReviewWorkflowDialog from './ReviewWorkflowDialog';
import SendForReviewDialogComponent from './SendForReviewDialogComponent';
import SendToTmfDialog from './SendToTmfDialog';
import VersionHistory from './VersionHistory';
import { DocumentUpload } from '../documentUpload/DocumentUpload';
import moment from 'moment';
import newconfig from '../../../appConfig';
import { Loader } from 'src/components/common/Loader';
import { hideLoader, showLoader } from 'src/store/Loader';
import OverwriteAndSendNewVersionDialog from './OverwriteAndSendNewVersionDialog';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
const DocumentViewerComponent = ({
  documentDetails,
  fetchUpdatedData,
  props,
  setDataGridComponent,
  setDisplayDoc,
  selection,
  isFromViewerVersionHistory = false
}: any) => {
  const isLoaderLoading: any = useSelector((state: AppState) => state.loader.isLoading);
  const [loaderStatus, setLoaderStatus] = useState(isLoaderLoading);
  const metaDataDetails: any = config.documentViewer?.metaDataDetails;
  const optionsMenu: any = config.documentViewer?.optionsMenu;
  const { t } = useTranslation();
  const metaDetailsLocale: any = t('metaDataDetails', { returnObjects: true });
  const documentDetail1: any = useSelector((state: AppState) => state.documentDetail);
  const documentDetail: any = documentDetails && isFromViewerVersionHistory ? documentDetails : documentDetail1;
  const documentKey: any = useAppSelector(state => state.preferences.documentKey);
  const isOtherAPPFileID = documentKey !== null ? Object.keys(documentKey).includes('file_master_id') : false;

  const [fileId, setFileId] = useState(
    isOtherAPPFileID ? documentKey.file_master_id : `${documentDetail?.data[0]?.fileId}`
  );
  const [openSendToTMF, setOpenSendToTMF] = useState(false);
  const [isFromVersionHistory, fromVersionHistory] = useState<any>(
    isFromViewerVersionHistory ? true : isOtherAPPFileID ? true : false
  );
  const [isSentToTMF, setIsSentToTMF] = useState(false);
  const viewer: any = useRef(null);
  const docService = new DocManagementService();
  const [pdfLoading, setPdfLoading] = useState(false);
  const [annotationsStatus, setAnnotationsStatus] = useState('');
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const xmlParser = new XMLParser();
  const token = useAppSelector(state => state.user.user?.token);
  const sponsor = useAppSelector(state => state.user.user?.sponsor_sponsor_name);
  const sponsorToken = useAppSelector(state => state.user.user?.sponsorToken);
  const [selectedRowDocumentDetails, setSelectedRowDocumentDetails] = useState<any>({});
  const { checkPermission, checkPermissionDocViewLevel } = usePermissionWrapper();
  const [openVersion, setOpenVersion] = useState(false);
  const [editedFmID, setEditedFmID] = useState('');
  const [docUrl, setDocUrl] = useState('');
  const [actionType, setActionType] = useState('');
  const isfLevel = documentDetail?.data[0]?.isf_doc_level;
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const entity = documentDetail?.data[0]?.isf_document_name;
  const [docVerisonDetails, setDocumentToDisplay1] = useState<any>({});
  const [progress, setProgress] = useState(0);
  const isIncludePhi = documentDetail?.data[0]?.isf_doc_viewer_includes_phi ? true : false;
  const isRedacted = documentDetail?.data[0]?.isf_doc_viewer_doc_phi_redacted === 'N' ? false : true;
  const docFromTmf = documentDetail.data[0]?.isf_doc_viewer_ref_model_version === 'TMF RM 3.2.1' ? true : false;
  const isBtnDisabled = isFromViewerVersionHistory
    ? documentDetail1.data[0]?.isBtnDisabled
    : documentDetail.data[0]?.isBtnDisabled;
  const [isDisabled, setDisabled] = useState(false);
  const [taskId, setTaskId] = useState('');
  const [taskTitle, setTaskTitle] = useState('');
  const [masterDocumentDetails, setMasterDocumentDetails] = useState({});
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const [latestVersion, setLatestVersion] = useState(0);
  const tmfArtifacts: any = [
    'CRF Corrections',
    'Informed Consent Form (signed)',
    'Internal Budget',
    'Signature & Initials',
    'Source data'
  ];
  const study = documentKey?.document_id ? documentDetail.data[0].isf_doc_study : selectedStudy;
  const country = selectedCountry ? selectedCountry : documentDetail.data[0].isf_doc_country;
  const site = selectedSite ? selectedSite : documentDetail.data[0].isf_doc_site;
  const isfInstance = axios.create({ baseURL: `${newconfig.appConfig.apiisf}` });
  const url = async (id: string) => {
    const downloadUrl =
      await `${appConfig.appConfig.apiisf}/fileMaster/downloadFile/${id}?log=Y&original=Y&study_id=${study}&country_id=${country}&site_id=${site}&isf_doc_level=${isfLevel}&application=${process.env.REACT_APP_NAME}&module_section_related=DocumentDownload&parent_entity_related=${entity}`;
    setDocUrl(downloadUrl);
  };

  const loadwebViewer = async (id: string) => {
    const downloadDocUrl = await `${appConfig.appConfig.apiisf}/fileMaster/downloadFile/${id}`;
    const result = await docService.getVersionHistory(
      documentDetail.data[0]?.isf_document_id,
      study,
      country,
      site,
      isfLevel,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      entity
    );
    setLatestVersion(result.data[0].document_version.isf_doc_version_number);
    const tempLatestVersion = result.data[0].document_version.isf_doc_version_number;
    const response: any = await docService.getMasterDocumentdetails(
      result.data[0]?.document_version.isf_doc_study,
      result.data[0]?.document_version.isf_document_id,
      documentDetail.data[0]?.isf_doc_version_number,
      country,
      site,
      isfLevel,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      result.data[0]?.isf_document_name
    );

    const docVersion = response?.data?.document_data?.isf_doc_version_number;

    if (docVersion >= tempLatestVersion) {
      setDisableButton(false);
      setDisableToTMF(false);
    } else {
      setDisableButton(true);
      setDisableToTMF(true);
    }

    if (response?.data?.need_sent_to_tmf === 'Yes' ? true : false) {
      if (documentDetail?.data[0].isf_doc_viewer_includes_phi) {
        if (documentDetail?.data[0].isf_doc_viewer_doc_phi_redacted !== 'N') {
          setIsSentToTMF(false);
        } else {
          setIsSentToTMF(true);
        }
      }
    } else {
      setIsSentToTMF(true);
    }
    if (response) setMasterDocumentDetails(response);
    setPdfLoading(false);
    WebViewer(
      {
        path: '/webviewer/lib',
        fullAPI: true,
        enableRedaction: true
      },
      viewer.current
    ).then(instance => {
      setPdfLoading(true);
      const { documentViewer } = instance.Core;
      const { annotationManager } = instance.Core;

      annotationManager.setCurrentUser(userName);
      instance.UI.setNoteDateFormat(`${userPreferedDateFormat.toUpperCase()} HH:MM A`);
      instance.UI.disableElements([
        'toolbarGroup-Shapes',
        'toolbarGroup-Insert',
        'toolbarGroup-Forms',
        'toolbarGroup-FillAndSign',
        'toolbarGroup-EditText'
      ]);

      const RedactValidation = () => {
        if (docVersion >= latestVersion) {
          if (documentDetail?.data[0].isf_doc_viewer_includes_phi) {
            if (documentDetail?.data[0].isf_doc_viewer_doc_phi_redacted !== 'N') {
              instance.UI.disableElements(['toolbarGroup-Redact']);
            } else {
              instance.UI.enableElements(['toolbarGroup-Redact']);
            }
          } else {
            instance.UI.disableElements(['toolbarGroup-Redact']);
          }
        } else {
          instance.UI.disableElements(['toolbarGroup-Redact']);
        }
      };

      if (checkPermission('redact_document_content')) {
        RedactValidation();
      } else {
        instance.UI.disableElements(['toolbarGroup-Redact']);
      }
      instance.UI.setToolbarGroup('toolbarGroup-View');
      instance.UI.disableElements(['textEditingPanel']);
      //Load pdf document.
      if (checkPermission('update_document_content')) {
        if (docVersion >= latestVersion) {
          instance.UI.enableElements(['contentEditButton']);
        } else {
          instance.UI.disableElements(['toolbarGroup-Edit', 'toolbarGroup-EditText', 'textEditingPanel']);
        }
      } else {
        instance.UI.disableElements(['toolbarGroup-Edit', 'toolbarGroup-EditText', 'textEditingPanel']);
      }
      instance.UI.loadDocument(downloadDocUrl, {
        filename: '',
        customHeaders: {
          Authorization: `bearer ${token}`,
          sponsor: sponsor,
          sponsor_token: sponsorToken,
          user_date_time: moment().format()
        }
      });

      /**
       * For updating the number of pages in FileInfo metadata section
       */
      documentViewer.addEventListener('pagesUpdated', async () => {
        const newPageCount = documentViewer.getPageCount();
        setDocumentDetail(dispatch, [
          {
            ...documentDetail.data[0],
            isf_doc_viewer_pages: newPageCount
          }
        ]);
        setConfirmExitValue(dispatch, true);
        setOpenVersion(false);
        instance.UI.enableElements(['save-document']);
        instance.UI.setHeaderItems((header: any) => {
          const length = header.headers.default.length;
          if (length === 14) {
            header.push({
              type: 'actionButton',
              title: 'save document',
              dataElement: 'save-document',
              color: '#243F81',
              img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/></svg>',
              onClick: async () => {
                instance.UI.disableElements(['save-document']);
                setPdfLoading(true);
                const doc = documentViewer.getDocument();
                const xfdfString = await annotationManager.exportAnnotations();

                const data = await doc.getFileData({
                  // saves the document with annotations in it
                  xfdfString
                });
                const arr = new Uint8Array(data);
                const fileToUpload = new Blob([arr], { type: 'application/pdf' });
                const file = new File([fileToUpload], documentDetail.data[0].tmf_raw_file_name, {
                  type: 'application/pdf'
                });
                const params = {
                  module_section_related: 'DocumentUpload',
                  parent_entity_related: documentDetail.data[0].isf_document_name
                };
                const response: any = await docService.fileUpload(
                  file,
                  progress => {
                    setProgress(progress);
                  },
                  isfLevel,
                  study,
                  country,
                  site,
                  process.env.REACT_APP_NAME,
                  'DocumentDetails',
                  entity
                );

                setEditedFmID(response.data.data.id);
                setDocumentDetail(dispatch, [
                  {
                    ...documentDetail.data[0],
                    editedFmID: response.data.data.id,
                    isf_doc_viewer_pages: response?.data?.data?.isf_doc_viewer_pages
                  }
                ]);
                setPdfLoading(false);
                setOpenVersion(true);
                setConfirmExitValue(dispatch, false);
                const contentEditManager = documentViewer.getContentEditManager();
                contentEditManager.endContentEditMode();
              }
            });
          }
        });
      });
      /**
       * End
       */

      documentViewer.addEventListener('documentLoaded', async () => {
        // Get annotation from database using API.
        setAnnotationsStatus('syncing-download');

        const response: any = await docService.getAnnotations(
          documentDetail.data[0]?.fmId,
          study,
          country,
          site,
          isfLevel,
          process.env.REACT_APP_NAME,
          'DocumentAnnotate',
          entity
        );
        if (response?.data) {
          setPdfLoading(false);
          annotationManager.importAnnotations(response?.data);
          setAnnotationsStatus('success');
        } else {
          if (response.error?.response?.status === 404) {
            setPdfLoading(false);
            setAnnotationsStatus('success');
          } else {
            setPdfLoading(false);
            setAnnotationsStatus('error');
          }
        }
      });
      instance.UI.setHeaderItems((header: any) => {
        const length: number = header.headers.default.length;
        if (length === 13) {
          header.push({
            type: 'actionButton',
            title: 'Back',
            dataElement: 'back-button',
            color: '#243F81',
            img: '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5238 6.84127V3L0 11.381L11.5238 19.7619V16.2698H22V6.84127H11.5238Z" fill="#243F81"/></svg>',
            onClick: async () => {
              if (checkPermission('redact_document_content')) {
                RedactValidation();
              } else {
                instance.UI.disableElements(['toolbarGroup-Redact']);
              }
              if (checkPermission('update_document_content')) {
                if (docVersion >= latestVersion) {
                  instance.UI.enableElements(['contentEditButton']);
                  instance.UI.setToolMode(instance.Core.Tools.ToolNames.CONTENT_EDIT);
                  instance.UI.setToolMode(instance.Core.Tools.ToolNames.ADD_PARAGRAPH);
                  instance.UI.setToolMode(instance.Core.Tools.ToolNames.ADD_IMAGE_CONTENT);
                  instance.UI.enableElements(['toolbarGroup-Edit', 'toolbarGroup-EditText']);
                } else {
                  instance.UI.disableElements(['toolbarGroup-Edit', 'toolbarGroup-EditText', 'textEditingPanel']);
                }
              } else {
                instance.UI.disableElements(['toolbarGroup-Edit', 'toolbarGroup-EditText', 'textEditingPanel']);
              }
              instance.UI.disableElements(['save-redact-document', 'save-document']);
            }
          });
        }
      });

      annotationManager.addEventListener('annotationChanged', async (annotations, action, { imported }) => {
        annotationManager.exportAnnotations().then(async (result: any) => {
          setAnnotationsStatus('syncing-upload');
          const xfdfDataObj: any = xmlParser.parse(result);
          if (annotations[0].Subject === 'Redact') {
            // instance.UI.enableElements(['save-redact-document']);
            // instance.UI.disableElements(['redactionPanel']);
            instance.UI.disableElements(['toolbarGroup-Edit', 'toolbarGroup-EditText', 'textEditingPanel']);
            const redactionList = annotationManager.getAnnotationsList();
            if (redactionList.length === 0) {
              instance.UI.disableElements(['save-redact-document']);
              setPdfLoading(true);

              const doc = documentViewer.getDocument();
              const xfdfString = await annotationManager.exportAnnotations();

              const data = await doc.getFileData({
                // saves the document with annotations in it
                xfdfString
              });
              const arr = new Uint8Array(data);
              const fileToUpload = new Blob([arr], { type: 'application/pdf' });
              const file = new File([fileToUpload], documentDetail.data[0].isf_raw_file_name, {
                type: 'application/pdf'
              });
              const response: any = await docService.fileUpload(
                file,
                progress => {
                  setProgress(progress);
                },
                isfLevel,
                study,
                country,
                site,
                process.env.REACT_APP_NAME,
                'DocumentDetails',
                entity
              );

              setDocumentDetail(dispatch, [
                {
                  ...documentDetail.data[0],
                  fileId: response.data.data.id
                }
              ]);
              const getAnnot: any = await docService.getAnnotations(
                documentDetail.data[0]?.fmId,
                study,
                country,
                site,
                isfLevel,
                process.env.REACT_APP_NAME,
                'DocumentAnnotate',
                entity
              );
              const sendAnnot = await docService.sendAnnotations(
                response.data.data.id,
                getAnnot?.data,
                study,
                country,
                site,
                isfLevel,
                process.env.REACT_APP_NAME,
                'DocumentAnnotate',
                entity
              );

              if (sendAnnot?.data) {
                setAnnotationsStatus('success');
              } else {
                setAnnotationsStatus('error');
              }
              const docDetails: any = masterDocumentDetails;
              const subartifactUpdateObj = {
                file_master_id: response.data.data.id,
                document_data: {
                  isf_artifact_number: docDetails.data.document_data.isf_artifact_number,
                  isf_document_name: docDetails.data.document_data.isf_document_name,
                  isf_doc_type: docDetails.data.document_data.isf_doc_type,
                  isf_doc_subtype: docDetails.data.document_data.isf_doc_subtype,
                  isf_doc_viewer_doc_phi_redacted: docDetails.data.document_data.isf_doc_viewer_doc_phi_redacted,
                  isf_doc_viewer_red_certified_copy: docDetails.data.document_data.isf_doc_viewer_red_certified_copy,
                  isf_doc_status: docDetails.data.document_data.isf_doc_status,
                  isf_doc_country: docDetails.data.document_data.isf_doc_country,
                  isf_doc_study: docDetails.data.document_data.isf_doc_study,
                  isf_doc_site: docDetails.data.document_data.isf_doc_site,
                  isf_doc_viewer_includes_phi: docDetails.data.document_data.isf_doc_viewer_includes_phi,
                  isf_doc_viewer_language: docDetails.data.document_data.isf_doc_viewer_language,
                  isf_doc_viewer_approval_cycle: docDetails.data.document_data.isf_doc_viewer_approval_cycle,
                  isf_doc_viewer_product_detail: docDetails.data.document_data.isf_doc_viewer_product_detail,
                  isf_doc_viewer_ref_model_version: docDetails.data.document_data.isf_doc_viewer_ref_model_version,
                  isf_doc_viewer_format: docDetails.data.document_data.isf_doc_viewer_format,
                  isf_doc_viewer_inspection_ready: docDetails.data.document_data.isf_doc_viewer_inspection_ready,
                  isf_doc_viewer_ir_issue_type: docDetails.data.document_data.isf_doc_viewer_ir_issue_type,
                  isf_doc_level: docDetails.data.document_data.isf_doc_level,
                  isf_artifact_name: docDetails.data.document_data.isf_artifact_name,
                  isf_doc_version_number: docDetails.data.document_data.isf_doc_version_number,
                  isf_doc_viewer_department: docDetails.data.document_data.isf_doc_viewer_department,
                  isf_doc_milestone: docDetails.data.document_data.isf_doc_milestone,
                  isf_document_id: docDetails.data.document_data.isf_document_id,
                  id: docDetails.data.document_data.id,
                  isf_doc_viewer_last_modified_by: userName
                }
              };

              const res = await docService.updateMasterDocument(
                subartifactUpdateObj,
                process.env.REACT_APP_NAME,
                'DocumentDetails',
                documentDetail.data[0]?.isf_document_name,
                true
              );
              if (res.data) {
                setPdfLoading(false);
                store.dispatch(setSnackbarMessage('Document is Redacted successfully.', 'success'));
                instance.UI.enableElements(['toolbarGroup-Edit', 'toolbarGroup-EditText', 'textEditingPanel']);
              } else {
                setPdfLoading(false);
                store.dispatch(setSnackbarMessage('Error in Reducting document.', 'error'));
              }
            }
          }
          //if (xfdfDataObj?.xfdf?.annots || xfdfDataObj?.xfdf?.annots['pdf-info']) {
          // localStorage.setItem(documentDetail.data[0]?.fmId, result);
          // setAnnotationsStatus('success');

          const selectedAnnotation = annotationManager.getSelectedAnnotations()[0];
          if (selectedAnnotation && selectedAnnotation.isContentEditPlaceholder()) {
            setOpenVersion(false);
            instance.UI.enableElements(['save-document', 'toolbarGroup-EditText', 'textEditingPanel']);
            instance.UI.disableElements(['toolbarGroup-Redact']);
            instance.UI.setHeaderItems((header: any) => {
              header.headers.default.splice(14, 2, {
                type: 'actionButton',
                title: 'Save Edited Document',
                dataElement: 'save-document',
                color: '#243F81',
                img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/></svg>',
                onClick: async () => {
                  setPdfLoading(true);
                  instance.UI.disableElements(['save-document']);
                  if (checkPermission('redact_document_content')) {
                    RedactValidation();
                  } else {
                    instance.UI.disableElements(['toolbarGroup-Redact']);
                  }
                  const doc = documentViewer.getDocument();
                  const xfdfString = await annotationManager.exportAnnotations();

                  const data = await doc.getFileData({
                    // saves the document with annotations in it
                    xfdfString
                  });
                  const arr = new Uint8Array(data);
                  const fileToUpload = new Blob([arr], { type: 'application/pdf' });
                  const file = new File([fileToUpload], documentDetail.data[0].isf_raw_file_name, {
                    type: 'application/pdf'
                  });
                  const response: any = await docService.fileUpload(
                    file,
                    progress => {
                      setProgress(progress);
                    },
                    isfLevel,
                    study,
                    country,
                    site,
                    process.env.REACT_APP_NAME,
                    'DocumentDetails',
                    entity
                  );
                  setEditedFmID(response.data.data.id);
                  setDocumentDetail(dispatch, [
                    {
                      ...documentDetail.data[0],
                      editedFmID: response.data.data.id
                    }
                  ]);
                  setPdfLoading(false);
                  setOpenVersion(true);
                }
              });
            });
            // save document button enabled
          }

          if (
            xfdfDataObj?.xfdf?.annots?.highlight?.contents !== undefined ||
            xfdfDataObj?.xfdf?.annots?.redact?.contents !== undefined ||
            xfdfDataObj?.xfdf?.annots?.text
          ) {
            const response = await docService.sendAnnotations(
              documentDetail.data[0]?.fmId,
              result,
              study,
              country,
              site,
              isfLevel,
              process.env.REACT_APP_NAME,
              'DocumentAnnotate',
              entity
            );
            if (response?.data) {
              setAnnotationsStatus('success');
            } else {
              setAnnotationsStatus('error');
            }
          }
        });
        // }
      });
    });
  };

  const getQualityControlDetailsById = async (status: string) => {
    const res = await docService.getActionName(
      documentDetail.data[0]?.isf_document_id,
      false,
      study,
      country,
      site,
      isfLevel,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      entity,
      true
    );

    const aftName = tmfArtifacts.filter((a: string) => a === documentDetail.data[0]?.isf_artifact_name);
    if (aftName.length > 0) {
      return setDisabled(true);
    } else {
      switch (status) {
        case 'Approved':
          return setDisabled(true);
        case 'Ready for approval':
          return setDisabled(true);
        case 'Uploaded':
          if (res.data.action_name === 'Send For Review') {
            return setDisabled(true);
          } else if (res?.data ? res?.data?.created_by_email !== user.email : false) {
            return setDisabled(true);
          } else {
            return setDisabled(false);
          }
          break;
      }
    }
  };

  const getActionName = async (documentId: string, taskId: string) => {
    let userBasedDetails = true;
    if (documentDetail.data[0].isf_doc_status === 'Approved') {
      userBasedDetails = false;
    }
    const result = await docService.getActionName(
      documentId,
      userBasedDetails,
      study,
      country,
      site,
      isfLevel,
      process.env.REACT_APP_NAME,
      'DocumentDetails',
      entity,
      false
    );

    if (documentDetail.data[0].isf_doc_status === 'Rejected') {
      if (result.error) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
    setActionType(result.data.action_name);
    setTaskId(result.data.task_id);
    setTaskTitle(result.data.task_title);
  };

  useEffect(() => {
    getQualityControlDetailsById(documentDetail.data[0]?.isf_doc_status);
  }, [isDisabled, documentDetail.data[0]?.isf_artifact_name]);

  useEffect(() => {
    window.scroll(0, 0);
    getActionName(documentDetail.data[0]?.isf_document_id, documentDetail.data[0]?.task_Id);
    if (fileId) {
      loadwebViewer(fileId);
      url(fileId);
    }
    if (!isBtnDisabled) setDisabled(false);
  }, [fileId, isIncludePhi, isRedacted, documentDetail.data[0]?.isf_doc_status]);

  const [expanded, setExpanded] = React.useState<string | false>('details');
  const handleToogleAccordion = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };
  const dispatch = useDispatch();
  const documentDetailsData: any = documentDetail.data[0];
  const data: any = GetMetaData(documentDetailsData);
  const [openAuditTrail, setOpenAuditTrail] = useState(false);
  const [openVersionHistory, setOpenVersionHistory] = useState(false);
  const [openSendForReviewDialog, setOpenSendForReviewDialog] = useState(false);
  const [openSendAsLinkDialog, setSendAsLinkDialog] = useState(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [openAddToTaskDialog, setOpenAddToTaskDialog] = useState(false);
  const [actionName, setActionName] = useState<string>('');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [buttonText, setButtonText] = useState('');
  const [openReviewDialog, setOpenReviewDialog] = useState(false);
  const [openApproveDialog, setOpenApproveDialog] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [openOverwriteAndNewversion, setOpenOverwriteAndNewversion] = useState(false);
  const [disableToTMF, setDisableToTMF] = useState(false);
  const open3 = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowDocumentDetails(row);
    setDocumentDetail(dispatch, [row]);
  };

  const handleSendForReviewClick = (action: string) => {
    setOpenSendForReviewDialog(true);
    setActionName(action);
  };

  const handleReadyForApprovalClick = (action: string) => {
    setOpenSendForReviewDialog(true);
    setActionName(action);
  };

  const handleClickDownload = (downloadUrl: any) => {
    const newState: any = store.getState();
    const headerConfig: any = {
      responseType: 'blob',
      headers: {
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    isfInstance
      .get(downloadUrl, headerConfig)
      .then(res => {
        fileDownload(
          res.data,
          `${documentDetail.data[0] && documentDetail.data[0]?.isf_document_name}_${parseFloat(
            documentDetail.data[0] && documentDetail.data[0]?.isf_doc_version_number
          ).toFixed(1)}.${
            documentDetail.data[0] && documentDetail.data[0]?.docFormat
              ? documentDetail.data[0]?.docFormat
              : documentDetail.data[0]?.isf_doc_viewer_format || 'PDF'
          }`
        );
        store.dispatch(setSnackbarMessage('Document is downloaded successfully.', 'success'));
      })
      .catch(error => {
        store.dispatch(setSnackbarMessage(`Enable to download document ${error}.`, 'error'));
      });
  };

  function handleClose3(optionMenuItem: any) {
    if (optionMenuItem.id === 'auditTrail') {
      setOpenAuditTrail(true);
    } else if (optionMenuItem.id === 'versionHistory') {
      setOpenVersionHistory(true);
    } else if (optionMenuItem.id === 'sendAsLink') {
      setSendAsLinkDialog(true);
    } else if (optionMenuItem.id === 'remove') {
      setOpenRemoveDialog(true);
    } else if (optionMenuItem.id === 'download') {
      handleClickDownload(docUrl);
    } else if (optionMenuItem.id === 'addToTasks') {
      setOpenAddToTaskDialog(true);
    }
    {
      setAnchorEl(null);
    }
  }

  const handleOpenDialog = async (text: string) => {
    setButtonText(text);
    if (text === 'Reject' || text === 'Complete Review') {
      setOpenReviewDialog(true);
    } else if (text === 'SendToTmf') {
      dispatch(showLoader());
      const response: any = await docService.VersionBasedDocuments({
        isf_document_ids: [documentDetail.data[0]?.isf_document_id]
      });
      if (response?.data) {
        setOpenOverwriteAndNewversion(true);
      } else {
        setOpenSendToTMF(true);
      }
    } else {
      setOpenApproveDialog(true);
    }
    dispatch(hideLoader());
  };
  const [checked, setChecked] = React.useState(true);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };
  useEffect(() => {
    setLoaderStatus(isLoaderLoading);
  }, [isLoaderLoading]);

  return checkPermission('view_uploaded_document') ? (
    <div>
      <Loader open={loaderStatus} />
      <h2 style={{ margin: 0 }}>Viewer</h2>
      <Grid container className="document-view-header" spacing={2}>
        <Grid item md={4.5}>
          <Typography>{documentDetail.data[0] && documentDetail.data[0]?.isf_document_name} </Typography>
        </Grid>
        <Grid item md={7.5} display="flex" justifyContent="flex-end">
          <Stack spacing={1} direction="row" sx={{ mb: 0.5 }}>
            <div>
              <Switch checked={checked} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
              <span>View Details</span>
            </div>
            {documentDetail.data[0].sent_to_tmf === true ? (
              <Alert severity="success" color="info">
                Document is sent to TMF
              </Alert>
            ) : documentDetail.data[0].isf_doc_status === 'Approved' &&
              documentDetail.data[0].isf_doc_version_number % 1 === 0 ? (
              <Stack spacing={1} direction="row">
                <Button
                  variant="contained"
                  className={
                    !checkPermission('send_to_tmf') ||
                    documentDetail.data[0].isf_doc_viewer_ref_model_version.slice(0, 3) === 'TMF'
                      ? 'hide'
                      : ''
                  }
                  onClick={() => handleOpenDialog('SendToTmf')}
                  disabled={isSentToTMF || disableToTMF}
                >
                  TO TMF
                </Button>
              </Stack>
            ) : actionType === 'Send For Review' ? (
              <Stack spacing={1} direction="row">
                <Button
                  variant="contained"
                  onClick={() => handleOpenDialog('Complete Review')}
                  disabled={disableButton}
                >
                  COMPLETE REVIEW
                </Button>
                <Button variant="contained" onClick={() => handleOpenDialog('Reject')} disabled={disableButton}>
                  REJECT
                </Button>
              </Stack>
            ) : actionType === 'Ready For Approval' ? (
              <Stack spacing={1} direction="row">
                <Button variant="contained" onClick={() => handleOpenDialog('Approve')} disabled={disableButton}>
                  APPROVE
                </Button>
                <Button
                  variant="contained"
                  onClick={() => handleOpenDialog('Review Feedback')}
                  disabled={disableButton}
                >
                  Review Feedback
                </Button>
              </Stack>
            ) : (
              <Stack spacing={1} direction="row">
                <Button
                  variant="contained"
                  className={documentDetail.data[0]?.isf_doc_status === 'Approved' ? 'hide' : ''}
                  disabled={
                    !checkPermissionDocViewLevel('send_document_for_approval', 'DocLevel') ||
                    !checkPermission('send_document_for_approval') ||
                    disableButton ||
                    isDisabled ||
                    isBtnDisabled
                  }
                  onClick={() => handleReadyForApprovalClick('Ready For Approval')}
                >
                  READY FOR APPROVAL
                </Button>
                <Button
                  variant="contained"
                  className={documentDetail.data[0]?.isf_doc_status === 'Approved' ? 'hide' : ''}
                  disabled={
                    !checkPermissionDocViewLevel('send_document_for_review', 'DocLevel') ||
                    !checkPermission('send_document_for_review') ||
                    disableButton ||
                    isDisabled ||
                    isBtnDisabled
                  }
                  onClick={() => handleSendForReviewClick('Send For Review')}
                >
                  SEND FOR REVIEW
                </Button>
              </Stack>
            )}
            <div>
              <Button
                className="grey-btn transparent-btn"
                id="demo-customized-button"
                aria-controls={open3 ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open3 ? 'true' : undefined}
                disableElevation
                onClick={(e: any) => handleClick(e, documentDetailsData)}
              >
                <MoreHorizIcon />
              </Button>
              <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                  'aria-labelledby': 'demo-customized-button'
                }}
                anchorEl={anchorEl}
                open={open3}
                onClose={handleClose3}
                className="more-button-list"
              >
                {optionsMenu?.map((optionMenuItem: any, index: number) => {
                  if (optionMenuItem.id === 'sendAsLink') {
                    if (optionMenuItem.isEnabled) {
                      return (
                        <MenuItem
                          onClick={() => handleClose3(optionMenuItem)}
                          disableRipple
                          disabled={!(checkPermission('send_document_as_link') && optionMenuItem.isEnabled)}
                          className={docFromTmf ? 'hide' : ''}
                          key={index}
                        >
                          {optionMenuItem.icon}
                          {optionMenuItem.name}
                        </MenuItem>
                      );
                    }
                  } else if (optionMenuItem.id === 'auditTrail') {
                    return (
                      <MenuItem
                        onClick={() => handleClose3(optionMenuItem)}
                        disabled={!checkPermission('view_audit_history') && optionMenuItem.isEnabled}
                        disableRipple
                        key={index}
                        className={docFromTmf ? 'hide' : ''}
                      >
                        {optionMenuItem.icon}
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  } else if (optionMenuItem.id === 'versionHistory') {
                    return (
                      <MenuItem
                        onClick={() => handleClose3(optionMenuItem)}
                        disabled={!checkPermission('view_version_history') && optionMenuItem.isEnabled}
                        disableRipple
                        key={index}
                        className={docFromTmf ? 'hide' : ''}
                      >
                        {optionMenuItem.icon}
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  } else if (optionMenuItem.id === 'download') {
                    return (
                      <MenuItem
                        disabled={!checkPermission('download_document')}
                        //disabled={!checkPermissionDocViewLevel('download_document', 'DocLevel')}
                        onClick={() => handleClose3(optionMenuItem)}
                        key={index}
                        disableRipple
                      >
                        {optionMenuItem.icon}
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  } else if (optionMenuItem.id === 'remove') {
                    return (
                      <MenuItem
                        disabled={
                          !checkPermission('delete_document')
                          //!checkPermissionDocViewLevel('delete_document', 'DocLevel')
                        }
                        key={index}
                        onClick={() => handleClose3(optionMenuItem)}
                        disableRipple
                        className={docFromTmf ? 'hide' : ''}
                      >
                        {optionMenuItem.icon}
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  } else if (optionMenuItem.id === 'addToTasks') {
                    return (
                      <MenuItem
                        disabled={
                          !checkPermission('add_to_task') ||
                          (documentDetail.data[0]?.isf_doc_latest_version
                            ? parseFloat(documentDetail.data[0]?.isf_doc_version_number)?.toFixed(1) !==
                              parseFloat(documentDetail.data[0]?.isf_doc_latest_version)?.toFixed(1)
                            : documentDetail.data[0]?.isf_doc_version_number < latestVersion)
                        }
                        onClick={() => handleClose3(optionMenuItem)}
                        disableRipple
                        key={index}
                        className={docFromTmf ? 'hide' : ''}
                      >
                        {optionMenuItem.icon}
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  } else if (optionMenuItem.isEnabled) {
                    return (
                      <MenuItem onClick={() => handleClose3(optionMenuItem)} disableRipple key={index}>
                        {optionMenuItem.icon}
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  }
                })}
              </StyledMenu>
            </div>
          </Stack>
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={12} sm={12} md={checked ? 8 : 12} className="doc-view-panel">
          <div className="App">
            {pdfLoading && (
              <Box sx={{ width: '100%' }}>
                <LinearProgress />
              </Box>
            )}

            {isFromVersionHistory ? (
              <div className="webviewer" ref={viewer} key={fileId}></div>
            ) : (
              <div
                className="webviewer"
                ref={viewer}
                key={
                  isIncludePhi
                    ? documentDetail.data[0]?.isf_doc_viewer_includes_phi
                      ? documentDetail.data[0]?.isf_doc_viewer_doc_phi_redacted
                      : fileId
                    : fileId
                }
              ></div>
            )}
          </div>
        </Grid>
        {checked ? (
          <Grid xs={12} sm={12} md={4} className="docview-details-accordion">
            <div className="pi-accordion">
              {metaDataDetails?.map((metaDataSection: any, index: any) => {
                if (index > 2) {
                  return (
                    <AccordionMetadataComponent
                      accordionInfo={{ name: metaDetailsLocale[metaDataSection.key], position: metaDataSection.key }}
                      expanded={expanded}
                      handleToogleAccordion={handleToogleAccordion}
                      data={data[metaDataSection.key]}
                      key={index}
                    ></AccordionMetadataComponent>
                  );
                } else {
                  return (
                    <>
                      {index === 0 && (
                        <MetaDetail
                          accordionInfo={{
                            name: metaDetailsLocale[metaDataSection.key],
                            position: metaDataSection.key
                          }}
                          expanded={expanded}
                          handleToogleAccordion={handleToogleAccordion}
                          documentProps={documentDetails}
                          fetchUpdatedData={fetchUpdatedData}
                          latestVersion={latestVersion}
                        />
                      )}
                      {index === 1 && (
                        <QualityControlDetail
                          accordionInfo={{
                            name: metaDetailsLocale[metaDataSection.key],
                            position: metaDataSection.key
                          }}
                          expanded={expanded}
                          handleToogleAccordion={handleToogleAccordion}
                          documentProps={documentDetails}
                          fetchUpdatedData={fetchUpdatedData}
                          actionType={actionType}
                        />
                      )}
                      {index === 2 && (
                        <MetricsDetails
                          accordionInfo={{
                            name: metaDetailsLocale[metaDataSection.key],
                            position: metaDataSection.key
                          }}
                          expanded={expanded}
                          handleToogleAccordion={handleToogleAccordion}
                          documentProps={documentDetails}
                          fetchUpdatedData={fetchUpdatedData}
                          actionType={actionType}
                        />
                      )}
                    </>
                  );
                }
              })}
            </div>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>

      {openSendForReviewDialog && (
        <SendForReviewDialogComponent
          openSendForReviewDialog={openSendForReviewDialog}
          setOpenSendForReviewDialog={setOpenSendForReviewDialog}
          qualityControlId={documentDetail.data[0]?.isf_quality_control_table_id}
          actionName={actionName}
          documentDetail={documentDetail}
          taskId={documentDetail.data[0]?.task_Id}
        />
      )}

      {openAuditTrail && (
        <AuditHistory
          openAuditTrail={openAuditTrail}
          setOpenAuditTrail={setOpenAuditTrail}
          setAnchorEl={setAnchorEl}
          setFileId={setFileId}
        />
      )}
      {openVersionHistory && (
        <VersionHistory
          openVersionHistory={openVersionHistory}
          setOpenVersionHistory={setOpenVersionHistory}
          setAnchorEl={setAnchorEl}
          setFileId={setFileId}
          fromVersionHistory={fromVersionHistory}
          setDocumentToDisplay1={setDocumentToDisplay1}
        />
      )}
      {openSendAsLinkDialog && (
        <SendasLink
          openSendAsLinkDialog={openSendAsLinkDialog}
          setSendAsLinkDialog={setSendAsLinkDialog}
          setAnchorEl={setAnchorEl}
          setFileId={setFileId}
          documentDetails={selectedRowDocumentDetails}
        />
      )}
      {openRemoveDialog && (
        <Remove
          openRemoveDialog={openRemoveDialog}
          setOpenRemoveDialog={setOpenRemoveDialog}
          props={props}
          setDataGridComponent={setDataGridComponent}
          selection={selection}
        />
      )}
      {openAddToTaskDialog && (
        <AddtoTasksDialogComponent
          openAddToTaskDialog={openAddToTaskDialog}
          setOpenAddToTaskDialog={setOpenAddToTaskDialog}
          actionName={actionName}
        />
      )}
      {openReviewDialog && (
        <ReviewWorkflowDialog
          openReviewDialog={openReviewDialog}
          setOpenReviewDialog={setOpenReviewDialog}
          buttonText={buttonText}
          setDisableButton={setDisableButton}
          taskId={taskId}
          taskTitle={taskTitle}
        />
      )}
      {openApproveDialog && (
        <ApprovalWorkflowDialog
          openApproveDialog={openApproveDialog}
          setOpenApproveDialog={setOpenApproveDialog}
          buttonText={buttonText}
          setDisableButton={setDisableButton}
          setIsSentToTMF={setIsSentToTMF}
          taskId={taskId}
          taskTitle={taskTitle}
        />
      )}
      {openSendToTMF && (
        <SendToTmfDialog
          openSendToTMF={openSendToTMF}
          setOpenSendToTMF={setOpenSendToTMF}
          taskId={taskId}
          setIsSentToTMF={setIsSentToTMF}
        />
      )}
      {openVersion && (
        <DocumentUpload dataGridComponent={true} openVersion={openVersion} docViewer={true} editedFmID={editedFmID} />
      )}
      {openOverwriteAndNewversion && (
        <OverwriteAndSendNewVersionDialog
          openOverwriteAndNewversion={openOverwriteAndNewversion}
          setOpenOverwriteAndNewversion={setOpenOverwriteAndNewversion}
          taskId={taskId}
          setIsSentToTMF={setIsSentToTMF}
        />
      )}
    </div>
  ) : (
    <Grid container justifyContent={'center'} alignItems="center" style={{ minHeight: '100vh' }}>
      <h4>You don’t have required permission to view the document. Please contact administrator</h4>
    </Grid>
  );
};

export default React.memo(DocumentViewerComponent);
